export function Stamp({ wp, stampUrl, size = 64, className = '' }) {
  const verified = wp.status === 'verified';
  const pending = wp.status === 'pending' || wp.status === 'queued';
  const ringColor = wp.status === 'queued' ? '#2563eb' : '#f59e0b';
  if (verified && stampUrl) {
    return <img src={stampUrl} alt={wp.category} style={{ width: size, height: size }} className={`object-contain drop-shadow ${className}`} draggable={false} />;
  }
  const color = wp.color || '#9ca3af';
  return (
    <div
      style={{ width: size, height: size, borderColor: verified ? color : pending ? ringColor : '#d1d5db', color: verified ? color : pending ? ringColor : '#d1d5db' }}
      className={`rounded-full border-[3px] ${verified ? 'border-double border-[5px]' : 'border-dashed'} flex items-center justify-center font-black select-none ${verified ? '-rotate-12' : ''} ${className}`}
    >
      <span style={{ fontSize: size * 0.42 }}>{verified ? '✓' : wp.status === 'queued' ? '↑' : pending ? '…' : ''}</span>
    </div>
  );
}

export default function PassportGrid({ waypoints, categories, stamps, onSelect }) {
  const scoring = waypoints.filter((w) => w.waypoint_type !== 'info');
  return (
    <div className="h-full overflow-y-auto bg-[#f5f1e8] p-3 space-y-5" data-testid="passport-grid">
      {categories.map((c) => {
        const list = scoring.filter((w) => w.category === c.category);
        if (!list.length) return null;
        return (
          <section key={c.category} data-testid={`passport-grid-cat-${c.category}`}>
            <h2 className="flex items-center gap-2 text-sm font-bold tracking-wide text-gray-800 mb-2">
              <span className="w-4 h-4 rounded-full border border-white shadow" style={{ backgroundColor: c.color || '#9ca3af' }} />
              {c.category}
              <span className="text-gray-500 font-medium">{c.verified}/{c.total}</span>
              {c.pending ? <span className="text-amber-600 text-xs">+{c.pending} en revisión</span> : null}
            </h2>
            <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-2">
              {list.map((w) => (
                <button
                  key={w.id}
                  type="button"
                  onClick={() => onSelect(w.id)}
                  className={`rounded-xl bg-white border p-1.5 flex flex-col items-center gap-1 active:scale-95 transition-transform ${w.status === 'verified' ? 'border-gray-300 shadow-sm' : 'border-dashed border-gray-300 opacity-80'}`}
                  data-testid={`passport-cell-${w.id}`}
                  data-status={w.status || 'none'}
                >
                  <Stamp wp={w} stampUrl={stamps?.[w.category]} size={52} />
                  <span className="text-[10px] leading-tight text-gray-700 text-center line-clamp-2 w-full">{w.name}</span>
                </button>
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}
